module.exports = __webpack_public_path__ + "static/media/icon-thumb@3x.616f72fc.png";